export const CONFIRMED_GET_ROLES = "CONFIRMED_GET_ROLES";
export const CONFIRMED_ADD_ROLE = "CONFIRMED_ADD_ROLE";
export const CONFIRMED_EDIT_ROLE = "CONFIRMED_EDIT_ROLE";
export const CONFIRMED_DELETE_ROLE = "CONFIRMED_DELETE_ROLE";
export const CONFIRMED_GET_MODULE_LIST = "CONFIRMED_GET_MODULE_LIST";
// export const  GET_ROLES_REQUEST= "GET_ROLES_REQUEST";
// export const  GET_ROLES_FAILURE= "GET_ROLES_FAILURE";